module.exports = __webpack_public_path__ + "img/accrf_logo.b00db1b8.png";